/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import { appStatuses, menuActions } from 'constants';
import { getDynamicUrl } from 'utils';
import { v4 as uuidv4 } from 'uuid';
import store from 'store';
import {
  polipop,
  //, menuPlacementsActions
} from 'constants';

export const chooseAdvertiserIconForFilter = {
  all_statuses: `rect {
        :nth-child(1) {
            fill: ${Palette.Emerald._500};
        }
        :nth-child(2) {
            fill: ${Palette.Amber._400};
        }
        :nth-child(3) {
            fill: ${Palette.PrimaryGray._400};
        }
    }`,
  all_but_archived: `rect {
        :nth-child(2) {
            fill: ${Palette.Emerald._500};
        }
        :nth-child(3) {
            fill: ${Palette.Amber._400};
        }
        :nth-child(1) {
            fill: inherit;
        }
    }`,
  promoting: `rect {
        :nth-child(3) {
            fill: ${Palette.Emerald._500};
        }
        :nth-child(2) {
            fill: inherit;
        }
        :nth-child(1) {
            fill: inherit;
        }
    }`,
  ready_to_promote: `rect {
        :nth-child(3) {
            fill: ${Palette.Amber._400};
        }
        :nth-child(2) {
            fill: inherit;
        }
        :nth-child(1) {
            fill: inherit;
        }
    }`,
  archived: `rect {
        :nth-child(3) {
            fill: ${Palette.PrimaryGray._400};
        }
        :nth-child(2) {
            fill: inherit;
        }
        :nth-child(1) {
            fill: inherit;
        }
    }`,
};

export const choosePublisherIconForFilter = {
  all_statuses: `rect {
        :nth-child(1) {
            fill: ${Palette.Emerald._500};
        }
        :nth-child(2) {
            fill: ${Palette.Red._400};
        }
        :nth-child(3) {
            fill: ${Palette.PrimaryGray._400};
        }
    }`,
  all_but_archived: `rect {
        :nth-child(2) {
            fill: ${Palette.Emerald._500};
        }
        :nth-child(3) {
            fill: ${Palette.Red._400};
        }
        :nth-child(1) {
            fill: inherit;
        }
    }`,
  monetising: `rect {
        :nth-child(3) {
            fill: ${Palette.Emerald._500};
        }
        :nth-child(2) {
            fill: inherit;
        }
        :nth-child(1) {
            fill: inherit;
        }
    }`,
  awaiting: `rect {
        :nth-child(3) {
            fill: ${Palette.Red._400};
        }
        :nth-child(2) {
            fill: inherit;
        }
        :nth-child(1) {
            fill: inherit;
        }
    }`,
  archived: `rect {
        :nth-child(3) {
            fill: ${Palette.PrimaryGray._400};
        }
        :nth-child(2) {
            fill: inherit;
        }
        :nth-child(1) {
            fill: inherit;
        }
    }`,
};

export const convertMenuItems = (items, isPublisher, is_deleted, isAdmin) => {
  const newItems = items.map((item) => {
    const newItem = { ...item, show: true };
    // if (!isPublisher && newItem.id === menuActions.app_settings && !isAdmin) {
    //   newItem.show = false;
    // }
    if (isPublisher && newItem.id === menuActions.promote_this_app) {
      newItem.show = false;
    }
    if (!isPublisher && newItem.id === menuActions.promote_this_app) {
      is_deleted ? (newItem.show = false) : (newItem.show = true);
    }
    if (is_deleted && newItem.id === menuActions.archive) {
      newItem.show = false;
    }
    if (!is_deleted && newItem.id === menuActions.restore) {
      newItem.show = false;
    }
    return newItem;
  });

  return newItems;
};

export const addUniqueIds = (array) => {
  const newArr = array.map((item) => ({
    package_id: item?.package_id,
    id: uuidv4(),
  }));
  return newArr;
};

export const addFieldStatus = (appsList) => {
  const { auth } = store.getState();
  const isAdvertiser = auth.pb_roles?.includes('advertiser');
  const apps = appsList?.map((item) => ({
    ...item,
    status: createFieldStatus(
      item.is_deleted,
      item.progress_status,
      isAdvertiser,
      item.has_campaign,
    ),
  }));
  return apps;
};

const createFieldStatus = (is_deleted, progress_status, isAdvertiser, has_campaign) => {
  if (is_deleted) return appStatuses.archived;
  if (progress_status < 0) return appStatuses.error;
  // אם יש קמפיינים, תמיד promoting
  if (has_campaign) return appStatuses.promoting;
  if (!isAdvertiser && progress_status === 1) return appStatuses.awaiting;
  if (isAdvertiser && progress_status === 2) return appStatuses.ready_to_promote;
  if (isAdvertiser && [3, 4].includes(progress_status)) return appStatuses.promoting;
  if (!isAdvertiser && progress_status > 1) return appStatuses.monetising;
  if (isAdvertiser && progress_status === 1) return appStatuses.ready_to_promote;
};

export function trimObjectValues(obj) {
  for (const prop in obj) {
    if (typeof obj[prop] === 'string') {
      obj[prop] = obj[prop].trim();
    }
  }
  return obj;
}

export const getUrl = (routes, id, pba_id) => {
  let link = '';
  if (id) {
    link = routes.list.find((r) => r.id === id).url;
    link = getDynamicUrl(link, {
      pba_id,
    });
  }

  return link;
};

export const showPolipop = (
  result,
  successAction = () => {},
  errorAction = () => {},
  onCloseAction = () => {},
) => {
  if (result.isSuccess) {
    polipop.add({
      content: 'Saved',
      title: 'Success',
      type: 'success',
      close: onCloseAction,
    });
    successAction();
  }
  if (result.error) {
    console.log(result);
    polipop.add({
      content: result?.error?.data?.title || result?.error?.data?.Message || result?.error?.data,
      title: 'Error',
      type: 'error',
    });
    errorAction();
  }
};

export function replaceNumberInUrl(url, number) {
  const regex = /\d+/;
  const match = url.match(regex);
  if (match) {
    return url.replace(match[0], number);
  }
  return url;
}

export const getCurrentPb_number = (url) => {
  const regex = /\d+/;
  const match = url.match(regex);
  return +match[0];
};

export const subdirectory = (img) => {
  if (img?.includes('app_img')) return 'apps';
  return 'banner';
};

//minimum serving. changes numbers values to strings
export function convertNumbersToStrings(data) {
  if (typeof data === 'object' && data !== null) {
    for (let key in data) {
      if (typeof data[key] === 'number') {
        data[key] = data[key].toString();
      } else {
        data[key] = convertNumbersToStrings(data[key]);
      }
    }
  }
  return data;
}

export const convertCountries = (countriesFromDataBase, newCountries) => {
  let newCountryList = newCountries.map((country) => country.cca2);
  const countriesForDelete = countriesFromDataBase
    .map((country) => {
      if (!newCountryList.includes(country.cca2)) {
        const victim = {
          ...country,
          directCpi: '',
          minCpi: '',
          minEcpm: '',
        };
        return victim;
      }
    })
    .filter(Boolean);
  const res = newCountries.concat(countriesForDelete);
  return res;
};

export function limitDecimal(e, onChange, decimals = 2) {
  const val = e.target.value;

  if (val === '' || new RegExp(`^\\d*\\.?\\d{0,${decimals}}$`).test(val)) {
    onChange(val);
  }
}

export function formatOnBlur(value, onChange) {
  if (value === '' || value == null) return;
  const num = parseFloat(value);
  if (isNaN(num)) return;

  onChange((+num).toString());
}

export function getErrorFieldName(field, fieldsObj) {
  if (!field || !fieldsObj) return '';
  const currentSectionObj = Object.values(fieldsObj).find((item) => item.field === field);
  return currentSectionObj?.countriesErrorName;
}

export function getNetworkAndDirectBuyNames(fieldsObj) {
  // there are two fields and two custom errors related to countries validation that can be attached to them
  const { field: networkField, countriesErrorName: networkCountriesError } = fieldsObj.network;
  const { field: directBuyField, countriesErrorName: directBuyCountriesError } =
    fieldsObj.directBuy;

  return { networkField, networkCountriesError, directBuyField, directBuyCountriesError };
}
